import React, { useState } from 'react'

import Button from '@react/react-spectrum/Button'
import Dialog from '@react/react-spectrum/Dialog'
import { Tab, TabView } from '@react/react-spectrum/TabView'

import { LaunchTab } from './LaunchTab'
import { ManualTab } from './ManualTab'

import { getNitrogenUrl } from 'services/environment'

export function ImsOrgDialog({
  environments,
  channel,
  projectName,
  projectType,
  launch,
  imsOrg,
  aep,
  onChange,
  ...otherProps
}) {
  const { onClose, ...modalProps } = otherProps
  const [config, setConfig] = useState({ imsOrg, aep, launch })

  const onSave = () => {
    onChange((i) => ({ ...i, ...config }))
    onClose()
  }

  const onUnlink = () => {
    onChange(({ imsOrg, aep, launch, target, tagManager, ...other }) => other)
    onClose()
  }

  return (
    <Dialog title='Select environment' onClose={onClose} {...modalProps} mode='fullscreen' role='dialog'>
      <div className='ImsOrgDialog'>
        <TabView>
          <Tab label='Automatic'>
            <LaunchTab
              {...config}
              environments={environments}
              channel={channel}
              projectName={projectName}
              projectType={projectType}
              onChange={setConfig}
            />
          </Tab>
          <Tab label='Manual'>
            <ManualTab {...config} environments={environments} onChange={setConfig} />
          </Tab>
        </TabView>
        <div className='ImsOrgDialog__buttons'>
          <em>
            Don't see a matching config? Adjust search filters or create a new config with{' '}
            <a href={getNitrogenUrl() + '/quick-setup'}>Quick&nbsp;Setup</a>.
          </em>
          <Button variant='warning' onClick={onUnlink}>
            Unlink all
          </Button>
          <Button onClick={onClose}>Close</Button>
          <Button variant='cta' onClick={onSave}>
            Save
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
